import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1x9epn75if: FaireBrandEntity = {
  token: "b_1x9epn75if",
  type: "brand",
  name: "Prim and Pure",
  avatarUrl:
    "https://cdn.faire.com/fastly/b6cf9f47677de95ee7499c7cb310a3e3bfe10e58d71bd2ff192a41f42e3b9396.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/67f46cf2e2bdb22973cdf7e65ebce62380fec5625153dc82d48800ac941e7dd9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b6cf9f47677de95ee7499c7cb310a3e3bfe10e58d71bd2ff192a41f42e3b9396.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/67f46cf2e2bdb22973cdf7e65ebce62380fec5625153dc82d48800ac941e7dd9.png",
  location: "Palm City, FL, USA",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Perspectives change with children. I started paying more attention to the products and chemicals around my home when I became a mother. Having dealt with some health issues, I wanted to reduce exposure to harmful chemicals, especially for my children. I soon found that countless products marketed towards our kids have harmful toxins or chemicals and lack visually appealing colors and character to delight those young, curious, questing eyes and minds. I founded Prim & Pure to support the creative play and developing imaginations of little ones without the worry of perpetually exposing them to potentially harmful toxins. Our goal is to provide Good - Clean - Fun! Prim & Pure is toxin-free makeup line for kids that made from clean and safe ingredients. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:59.979Z",
    importedBy: "entity-db-cli",
  },
};
